module.exports = __webpack_public_path__ + "img/kiet.f3d99f8e.jpeg";